import styled from 'styled-components';

export const StyledHeader = styled.div`
  background: #f5f7f9;
  z-index: 1;
  display: flex;
  align-items: flex-end;
  background-color: #f5f7f9;
  height: 56px;
  border-bottom: 1px #cfd7df solid;
  padding: 0 16px;
  box-shadow: 0 2px 4px 0 rgba(24, 50, 71, 0.08);
  position: sticky;
  top: 64px;

  span.label {
    padding: 8px 15px;
    text-align: center;
  }
`;
